import { createContext, useContext } from "react"

type RadioGroupProps = {
  name: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  selectedValue: string
  disabled?: boolean
  shouldRender?: (value?: string) => boolean
}

const RadioGroupContext = createContext<RadioGroupProps>(null as any)

const RadioGroup = ({
  children,
  ...props
}: RadioGroupProps & {
  children: React.ReactNode
}) => {
  return <RadioGroupContext.Provider value={props}>{children}</RadioGroupContext.Provider>
}

export default RadioGroup

export const useRadioGroup = () => {
  return useContext(RadioGroupContext)
}
